const state = {
  data: 0,
};

const getters = {};

const actions = {

};

const mutations = {
  REFRESH(state) {
    state.data = new Date().getTime();
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
